import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, from } from 'rxjs';

@Injectable()
export class ApiService {

	constructor(private readonly http: HttpClient) {}

	get(
		endpoint: string,
		params: HttpParams = new HttpParams()
	): Observable<any> {
		return from(this.http.get(endpoint, { params }));
	}

	post(endpoint: string, payload: any): Observable<any> {
		return from(this.http.post(endpoint, payload));
	}

	put(endpoint: string, payload: any): Observable<any> {
		return from(this.http.put(endpoint, payload));
	}

	delete(endpoint: string): Observable<any> {
		return from(this.http.delete(endpoint));
	}

	patch(endpoint: string, payload: any): Observable<any> {
		return from(this.http.patch(endpoint, payload));
	}
}
